import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=1252c5b0&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=ts"
export * from "./PdfPreview.vue?vue&type=script&lang=ts"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=1252c5b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252c5b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1252c5b0')) {
      api.createRecord('1252c5b0', component.options)
    } else {
      api.reload('1252c5b0', component.options)
    }
    module.hot.accept("./PdfPreview.vue?vue&type=template&id=1252c5b0&scoped=true", function () {
      api.rerender('1252c5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/PdfPreview.vue"
export default component.exports